import { useCallback } from 'react'
import ClassNames from 'classnames'
import Button from '@material-ui/core/Button'

import l10n from '../../i18n/I18N'
import { config } from '../../Init/Init'
import { paymentModes } from '../cryptoPaymentConstants'
import { CryptoPaymentDepositForm } from '../CryptoPaymentDeposit'
import { CryptoPaymentWithdrawalForm } from '../CryptoPaymentWithdrawal'
import { useCryptoPaymentDataModal } from '../CryptoPaymentModalDataProvider'
import { useCryptoPaymentModal } from '../CryptoPaymentModalProvider'
import { verifyNotFrozen } from '../../../services/utils'
import { useModals } from '../../../services/providers/ModalsProvider'
import { usePlayerStore } from '../../../services/store'

import classes from './cryptoPayment.module.scss'

export const CryptoPayment = () => {
  const playerStore = usePlayerStore()
  const playerKycStatus = playerStore.use.kycStatus()
  const playerFreezeInfo = playerStore.use.playerFreezeInfo()
  const playerSocialData = playerStore.use.socialData()

  const {
    loading,
    setLoading,
    withdrawalFormRef,
    cryptoPaymentModalMode,
    setWithdrawalFormError,
    setCryptoPaymentModalMode
  } = useCryptoPaymentDataModal()

  const { setCryptoPaymentModalPackageAmount } = useCryptoPaymentModal()
  const { openKycModal } = useModals()

  const purchaseLabel = config.enableSweepstakes
    ? l10n.t['cryptopayment.purchase.button']
    : l10n.t['cryptopayment.deposit.button']

  const redeemLabel = config.enableSweepstakes
    ? l10n.t['cryptopayment.redeem.button']
    : l10n.t['cryptopayment.withdraw.button']

  const depositButtonClassName = ClassNames(classes.cryptoPaymentModeButton, {
    [classes.cryptoPaymentModeButton_selected]: cryptoPaymentModalMode === paymentModes.deposit
  })
  const withdrawalButtonClassName = ClassNames(classes.cryptoPaymentModeButton, {
    [classes.cryptoPaymentModeButton_selected]: cryptoPaymentModalMode === paymentModes.withdrawal
  })

  const handleDepositButtonClick = useCallback(() => {
    if (!loading && cryptoPaymentModalMode !== paymentModes.deposit) {
      setCryptoPaymentModalMode(paymentModes.deposit)
      setLoading(true)
      setWithdrawalFormError('')
    }
  }, [cryptoPaymentModalMode, loading, setCryptoPaymentModalMode, setLoading, setWithdrawalFormError])

  const handleWithdrawalButtonClick = useCallback(() => {
    if (playerKycStatus !== config.kycStatuses.Verified && config.enableCryptoWallet) {
      return openKycModal()
    }

    if (!loading && cryptoPaymentModalMode !== paymentModes.withdrawal) {
      setCryptoPaymentModalMode(paymentModes.withdrawal)
      setCryptoPaymentModalPackageAmount(null)
    }
  }, [
    cryptoPaymentModalMode,
    loading,
    openKycModal,
    playerKycStatus,
    setCryptoPaymentModalMode,
    setCryptoPaymentModalPackageAmount
  ])

  const isPurchaseButtonDisabled =
    loading ||
    !verifyNotFrozen(playerFreezeInfo, config.freezeEvents.depositFrozen) ||
    (playerSocialData?.features &&
      playerSocialData?.features.indexOf(config.classicAccountFeatures.sweepsStoreBlocked) > -1)

  const isWithdrawButtonDisabled = loading || !verifyNotFrozen(playerFreezeInfo, config.freezeEvents.withdrawFrozen)

  return (
    <>
      <div className={classes.cryptoPaymentHeader}>{l10n.t['cryptopayment.header']}</div>
      <div className={classes.cryptoPaymentModeButtonGroup}>
        <Button
          className={depositButtonClassName}
          disabled={isPurchaseButtonDisabled}
          onClick={handleDepositButtonClick}
        >
          {purchaseLabel}
        </Button>
        <Button
          className={withdrawalButtonClassName}
          disabled={isWithdrawButtonDisabled}
          onClick={handleWithdrawalButtonClick}
        >
          {redeemLabel}
        </Button>
      </div>
      {cryptoPaymentModalMode === paymentModes.deposit && <CryptoPaymentDepositForm />}
      {cryptoPaymentModalMode === paymentModes.withdrawal && <CryptoPaymentWithdrawalForm ref={withdrawalFormRef} />}
    </>
  )
}
